import { render, staticRenderFns } from "./baseData.vue?vue&type=template&id=3934ad13&scoped=true&"
import script from "./baseData.vue?vue&type=script&lang=js&"
export * from "./baseData.vue?vue&type=script&lang=js&"
import style0 from "./baseData.vue?vue&type=style&index=0&id=3934ad13&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3934ad13",
  null
  
)

export default component.exports